<template>
  <div class="ny-radio">
    <el-radio-group
      class="is-half"
      :class="{ 'is-multiple': multiple, 'is-large': large }"
      v-model="currentValue"
      v-bind="$attrs"
    >
      <el-radio
        v-for="item in data"
        :key="item[keyValue[0]]"
        :label="item[keyValue[0]]"
        :disabled="disabledData.indexOf(item[keyValue[0]]) > -1"
      >{{item[keyValue[1]]}}</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: 'NyRadio',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    multiple: Boolean,
    large: Boolean,
    keyValue: {
      type: Array,
      default: () => ['value', 'name']
    },
    disabledData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal;
    },
    currentValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped>
</style>
